module.exports = __webpack_public_path__ + "img/icon-email.4baf5aaf.svg";